// extracted by mini-css-extract-plugin
export var editor = "_1g-0";
export var flowSidebar = "_44-2";